import { render, staticRenderFns } from "./PopOverLink.vue?vue&type=template&id=0979a890"
import script from "./PopOverLink.vue?vue&type=script&lang=js"
export * from "./PopOverLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports